module.exports = __webpack_public_path__ + "img/icon_xiaoku.0d62e46d.png";